import Paper from '@trackman/web-shared-components/components/Paper/Paper';
import { CertificationCompletionEntry } from 'types/admin/analytics';
import { CertificationTrendsChart } from '../CertificationTrendsChart/CertificationTrendsChart';
import { KpiMeta } from '../KpiMeta/KpiMeta';
import { getUserCountFrom30DaysAgo } from 'utilities/certificationCompletions';
import { KpiBase } from '../KpiBase/KpiBase';

export const SingleCertificateTrendChartCard = ({
  completions,
  color,
}: {
  completions: [string, CertificationCompletionEntry];
  color: string;
}) => {
  const totalUserCounts = Object.values(completions[1].userCountsByDate).reduce((acc, count) => acc + count, 0);
  const changeInUserCountsVsPreviousMonth = totalUserCounts - getUserCountFrom30DaysAgo(completions[1]);

  return (
    <Paper className='analytics-card kpi-card'>
      <KpiBase label={completions[1].certificationName} value={totalUserCounts} sources={['DB']} />
      <KpiMeta tone={changeInUserCountsVsPreviousMonth >= 0 ? 'positive' : 'negative'}>
        {changeInUserCountsVsPreviousMonth >= 0 ? `+${changeInUserCountsVsPreviousMonth}` : changeInUserCountsVsPreviousMonth} this month
      </KpiMeta>
      <CertificationTrendsChart trends={[completions]} chartColors={[color]} />
    </Paper>
  );
};
